import { render, staticRenderFns } from "./SDKList.vue?vue&type=template&id=46256326&scoped=true"
import script from "./SDKList.vue?vue&type=script&lang=js"
export * from "./SDKList.vue?vue&type=script&lang=js"
import style0 from "./SDKList.vue?vue&type=style&index=0&id=46256326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46256326",
  null
  
)

export default component.exports